import { Get, getAPIUrl, Post } from "../../ApiServices/apiMethod";

export const MinesEndpoint = {
  betting: "mines/betting",
  doCashout: "mines/do-cashout",
  minesOption:"mines/option-list",
  // walletBalance: "user/wallet-balance",
};

export const ApplyMinesBet = (data, param = "") => {
  const url = getAPIUrl(MinesEndpoint.betting, param);
  return Post(url, data);
};
export const DoMineCahsout = (data, param = "") => {
  const url = getAPIUrl(MinesEndpoint.doCashout, param);
  return Post(url, data);
};

export const getMinesOptionList = ( param = "") => {
  const url = getAPIUrl(MinesEndpoint.minesOption, param);
  return Get(url);
};
// export const getWallletBalance = (param = "") => {
//   const url = getAPIUrl(MinesEndpoint.walletBalance, param);
//   return Get(url);
// };